import React, { useEffect } from 'react';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import SelectAsyncComponent from '@componentes/select/select-async.component';
import DateInput from '@componentes/datepicker/react-datepicker.component';
import BlocoContainer from '../bloco/bloco.container';
import { components } from 'react-select';
import JustificativaComponent from '@componentes/justificativa/justificativa.component';
import * as acessos from '../../../../../acessos.const.util';
import SelectComponent from '@componentes/select/select.component';
import SelectCreatableComponent from '@componentes/select/select-creatable.component';
import IntlMessage from '../../../../../helpers/intlMessage';

import { useIntl } from 'react-intl';

const LaminaPage = props => {
  const { Option } = components;

  const intl = useIntl();

  function translate(key) {
    return intl.formatMessage({ id: key });
  }

  const apagarBlocoCongelacao = async option => {
    await props.deletarBloco(option);
  };
  const apagarComplementoCongelacao = async (id, str) => {
    await props.apagarComplemento(id, str);
  };


  const IconOptionBloco = props => (
    <Option {...props}>
      {props.data.label}
      <button
        onClick={() => apagarBlocoCongelacao(props.data.value)}
        className='close'
      >
        <i
          style={{
            fontSize: 13,
            float: 'right',
            marginTop: 5
          }}
          className='fas fa-trash fa-2x'
        ></i>
      </button>
    </Option>
  );

  const IconOptionComplemento = props => (
    <Option {...props}>
      {props.data.label}
      <button
        onClick={() =>
          apagarComplementoCongelacao(props.data.value, props.data.label)
        }
        className='close'
      >
        <i
          style={{
            fontSize: 13,
            float: 'right',
            marginTop: 5
          }}
          className='fas fa-trash fa-2x'
        ></i>
      </button>
    </Option>
  );

  return (
    <React.Fragment>
      <JustificativaComponent
        isOpen={props.showModalJustificativa}
        toggle={props.toggleModalJustificativa}
        setJustificativa={props.setJustificativa}
        justificativa={props.justificativa}
        onClick={props.modalConfirmarApagar}
        title='Exclusão de Bloco'
        label='Justificativa da Exclusão'
        btnText='Confirmar Exclusão'
        placeholder='Justificativa para a exclusão'
      />
      <Modal
        size='xl'
        isOpen={props.openModalBloco}
        toggle={props.toggleModalBloco}
      >
        <ModalHeader>
          <IntlMessage id="dashboards.examDetail.requisitionFreezingReport" /> - {`${props.laudo}`}
        </ModalHeader>
        <ModalBody>
          <BlocoContainer laudo={props.laudo} nrExame={props.nr_exame} />
        </ModalBody>
        <ModalFooter>
          <Button
            className='modalComponente-fechar'
            color='secondary'
            onClick={props.toggleModalBloco}
          >
            <IntlMessage id="dashboards.examDetails.cancel" />
          </Button>
        </ModalFooter>
      </Modal>
      <div className='citologia-modal-page mv-requisicao-congelacao-page'>
        <Row>
          <Col>
            <Label><IntlMessage id="dashboards.examDetail.freezingBlock" /></Label>
            <InputGroup>
              <div style={{ flex: 1, height: '38px' }}>
                <SelectComponent
                  isClearable={true}
                  components={{
                    Option: IconOptionBloco
                  }}
                  options={props.blocosCongelacao}
                  onChange={el =>
                    props.alterarValorState('blocoCongelacao', el)
                  }
                  value={props.blocoCongelacao}
                  placeholder={translate("dashboards.examDetail.selectFreezingBlock")}
                  noOptionsMessage={() =>
                    <IntlMessage id="dashboards.examDetail.noFreezeBlock" />
                  }
                  disabled={
                    props.laudoNaoExiste ||
                    !props.blocosCongelacao ||
                    props.isEdicao
                  }
                />
              </div>
              {props.acessoPermitido(
                props.usuario,
                acessos.AdicionarBlocos
              ) && (
                  <Button
                    color='secondary'
                    className='input-group-text'
                    onClick={() => props.toggleModalBloco()}
                    disabled={props.laudoNaoExiste}
                  >
                    <IntlMessage id="dashboards.examDetail.addBlock" />
                  </Button>
                )}
            </InputGroup>
          </Col>
        </Row>
        <br></br>
        <Row>
          <Col>
            <FormGroup>
              <Label><IntlMessage id="dashboards.examDetail.bladeAddOn" /></Label>
              <SelectCreatableComponent
                components={{
                  Option: IconOptionComplemento
                }}
                onChange={ev => props.alterarValorState('complemento', ev)}
                onCreateOption={props.handleCreateSelectCreatable}
                options={props.complementos}
                placeholder={translate("dashboards.examDetail.selectBladeAddOn")}
                label={<IntlMessage id="dashboards.examDetail.registerNewAddOn" />}
                value={props.complemento}
                disabled={props.laudoNaoExiste}
              />
            </FormGroup>
          </Col>
          <Col className='w-130'>
            <FormGroup>
              <Label className='label-centralizado'><IntlMessage id="dashboards.examDetail.qtyBlades" /></Label>
              <div className='qtd-laminas-group'>
                <button
                  disabled={props.laudoNaoExiste || props.isEdicao}
                  className='qtd-laminas-button float-left'
                  onClick={() =>
                    props.alterarValorState('qtdLaminas', props.qtdLaminas - 1)
                  }
                >
                  <i className='fas fa-minus'></i>
                </button>
                <Input
                  style={{ width: '40px' }}
                  type='number'
                  value={props.qtdLaminas}
                  disabled={props.laudoNaoExiste || props.isEdicao}
                  onChange={ev =>
                    props.alterarValorState(
                      'qtdLaminas',
                      ev.currentTarget.value
                    )
                  }
                />
                <button
                  disabled={props.laudoNaoExiste || props.isEdicao}
                  className='qtd-laminas-button float-left'
                  onClick={() =>
                    props.alterarValorState('qtdLaminas', props.qtdLaminas + 1)
                  }
                >
                  <i className='fas fa-plus'></i>
                </button>
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label><IntlMessage id="dashboards.examDetail.annotations" /></Label>
              <Input
                type='textarea'
                maxLength={300}
                disabled={props.laudoNaoExiste}
                value={props.observacoes}
                onChange={ev => props.alterarObservacoes(ev.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label><IntlMessage id="dashboards.examDetail.unconformities" /></Label>
              <SelectComponent
                options={props.naoconformidades}
                onChange={ev =>
                  props.alterarValorState('nConfInclusaoLamina', ev)
                }
                value={props.nConfInclusaoLamina}
                disabled={props.laudoNaoExiste}
                placeholder={translate("dashboards.examDetail.selectUnconformities")}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col sm={2}>
            <FormGroup>
              <Label><IntlMessage id="dashboards.examDetail.date" /></Label>
              <DateInput
                className='filtro-data'
                value={props.dataInclusaoLamina}
                readOnly={true}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label><IntlMessage id="dashboards.examDetail.freezingTechnician" /></Label>
              <SelectAsyncComponent
                options={props.tecnicos}
                value={props.tecnico}
                placeholder={translate("dashboards.examDetail.selectTechnician")}
                disabled={props.laudoNaoExiste}
                onChange={ev => {
                  props.alterarValorState('tecnico', ev);
                }}
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label><IntlMessage id="dashboards.examDetail.freezingPathologist" /></Label>
              <SelectAsyncComponent
                options={props.patologistas}
                value={props.patologista}
                placeholder={translate("dashboards.examDetail.selectPathologist")}
                disabled={props.laudoNaoExiste}
                onChange={ev => {
                  props.alterarValorState('patologista', ev);
                }}
              />
            </FormGroup>
          </Col>

          <footer style={{left: '5px', width: '1030px'}}>
            {!props.laudoNaoExiste && (
              <Button
                color='danger'
                onClick={props.limparCamposAdicionarLaminas}
                style={{marginLeft: '0px'}}
              >
                <IntlMessage id="dashboards.examDetail.clearFields" />
              </Button>
            )}
            <Button
              color='primary'
              onClick={e => {
                if (props.laminaId && props.laminaId>0) {
                  props.editarLaminaId(e);
                } else {
                  props.adicionarLamina(e);
                }
              }}
              disabled={
                !(
                  props.qtdLaminas > 0 &&
                  props.laudo !== '' &&
                  props.tecnico !== null &&
                  !props.laudoNaoExiste &&
                  !props.laudo.length < 8
                )
              }
            >
              {props.laminaText}
            </Button>
          </footer>
        </Row>
      </div>
    </React.Fragment >
  );
};

export default LaminaPage;



// WEBPACK FOOTER //
// ./src/app/common/requisicaoCongelacao/tabs/lamina/lamina.page.js